import { Button } from '@mui/material';
import { FaFileExcel } from 'react-icons/fa6';
import { useLocation, useNavigate } from 'react-router-dom';

const ExportImportArticles = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleOpenExcelModal = () => {
    const hasTrailingSlash = location.pathname.endsWith('/');
    if (!hasTrailingSlash) {
      navigate(`${location.pathname}/articles-excel`);
    } else {
      navigate(`${location.pathname}articles-excel`);
    }
  };
  return (
    <Button size="small" variant="contained" color="success" startIcon={<FaFileExcel />} onClick={handleOpenExcelModal}>
      Import/ export
    </Button>
  );
};

export default ExportImportArticles;
